export default {
  isLoggedIn: null,
  __typename: 'Auth'
};
